import { createRouter, createWebHistory } from 'vue-router';
import Dialog from 'quasar/src/plugins/Dialog.js';;
import store from '@/store';
import { UPDATE_ROLE } from '@/store/actions.type';
import { getModuleSettingInstance } from '@/utils/auth';

const routes = [
  // Login
  {
    path: '/',
    component: () => import('../layouts/LoginLayout.vue'),
    redirect: '/login',
    children: [
      {
        path: '/login',
        component: () => import('../views/LoginPage.vue'),
      },
      {
        path: '/logout',
        component: () => import('../views/LogoutPage.vue'),
      },
      {
        path: '/login/pr-approval/in-process/:prApprovalItemId',
        component: () => import('../views/LoginPage.vue'),
        props: true,
      },
      {
        path: '/login/sourcing-approval/in-process/:nonCartApprovalItemId',
        component: () => import('../views/LoginPage.vue'),
        props: true,
      },
      {
        path: '/login/po-approval/in-process/:poApprovalItemId',
        component: () => import('../views/LoginPage.vue'),
        props: true,
      },
      {
        path: '/login/payment-request-approval/in-process/:paymentApprovalItemId',
        component: () => import('../views/LoginPage.vue'),
        props: true,
      },
      {
        path: '/login/procurement-sourcing-approval/in-process/:sourcingApprovalItemId',
        component: () => import('../views/LoginPage.vue'),
        props: true,
      },
    ],
  },

  // Requester
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      // Catalog
      {
        path: '/catalog/:productDetailId?',
        name: 'catalog',
        component: () => import('../views/requester/catalog/CatalogPage.vue'),
        props: true,
      },
      {
        path: '/catalog/product-details/:catalogItemId/:productTitle?',
        name: 'product-details',
        component: () =>
          import('../views/requester/catalog/ProductDetails.vue'),
        props: true,
      },
      {
        path: '/catalog/compare-products',
        component: () =>
          import('../views/requester/catalog/CompareProducts.vue'),
      },
      {
        path: '/catalog/cart/:cartId?',
        name: 'cart',
        component: () => import('../views/requester/catalog/CartPage'),
        props: true,
      },
      {
        path: '/catalog/search-result',
        name: 'search-result',
        component: () =>
          import('../views/requester/catalog/SearchResultPage.vue'),
      },
      // Shopping Cart
      {
        path: '/shopping-cart',
        component: () =>
          import('../views/requester/shopping-cart/ShoppingCartPage.vue'),
      },
      {
        path: '/cancel-po-request',
        component: () =>
          import('../views/requester/cancel-po/CancelPOPage.vue'),
      },
      {
        path: '/cancel-po-details/:poId',
        component: () =>
          import('../views/requester/cancel-po/CancelPODetail.vue'),
        props: true,
      },
      // Non-Catalog
      {
        path: '/non-catalog',
        component: () =>
          import('../views/requester/non-catalog/NonCatalogPage.vue'),
      },
      {
        path: '/non-catalog/draft/:nonCartId?',
        component: () => import('../views/requester/non-catalog/Draft.vue'),
        props: true,
      },
      {
        path: '/non-catalog/in-process/:nonCartId',
        component: () => import('../views/requester/non-catalog/InProcess.vue'),
        props: true,
      },
      {
        path: '/non-catalog/history/:nonCartId',
        component: () => import('../views/requester/non-catalog/History.vue'),
        props: true,
      },
      // Receipt
      {
        path: '/receipt',
        component: () => import('../views/requester/receipt/ReceiptList.vue'),
        props: true,
      },
      {
        path: '/receipt/in-process/:poId',
        component: () => import('../views/requester/receipt/InProcess.vue'),
        props: true,
      },
      {
        path: '/receipt/waiting-for-cancel-approved/:poId',
        component: () =>
          import('../views/requester/receipt/WaitingForCancelApproved.vue'),
        props: true,
      },
      {
        path: '/receipt/history/:poReceiptId',
        component: () => import('../views/requester/receipt/History.vue'),
        props: true,
      },
      {
        path: '/receipt/vef-in-process/:data',
        component: () => import('../views/requester/receipt/VEFInProcess.vue'),
        props: true,
      },
      {
        path: '/receipt/vef-history/:data',
        component: () => import('../views/requester/receipt/VEFHistory.vue'),
        props: true,
      },
      {
        path: '/reports',
        component: () =>
          process.env?.VUE_APP_ENABLE_REQUESTER_MENU_REPORT === 'yes'
            ? import('../views/requester/reports/List.vue')
            : import('../views/ErrorNotFound.vue'),
        props: true,
      },
      {
        path: '/reports/1',
        component: () =>
          process.env?.VUE_APP_ENABLE_REQUESTER_MENU_REPORT === 'yes'
            ? import('../views/requester/reports/Operational.vue')
            : import('../views/ErrorNotFound.vue'),
        props: true,
      },
      {
        path: '/reports/1/:resultID',
        component: () =>
          process.env?.VUE_APP_ENABLE_REQUESTER_MENU_REPORT === 'yes'
            ? import('../views/requester/reports/OperationalDetail.vue')
            : import('../views/ErrorNotFound.vue'),
        props: true,
      },
    ],
    meta: {
      requireAuth: true,
      requireRole: 'Requester',
    },
  },

  // Procurement
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      // Sourcing Request
      {
        path: '/sourcing-request',
        component: () =>
          import('../views/procurement/sourcing-request/SourcingRequest.vue'),
      },
      {
        path: '/sourcing-request/in-process/:nonCartId',
        component: () =>
          import('../views/procurement/sourcing-request/InProcess.vue'),
        props: true,
      },
      // {
      //   path: "/sourcing-request/waiting-for-approval/:nonCartId",
      //   component: () =>
      //     import("../views/procurement/sourcing-request/WaitingForApproval.vue"),
      //   props: true,
      // },
      // {
      //   path: "/sourcing-request/history/:nonCartId",
      //   component: () =>
      //     import("../views/procurement/sourcing-request/History.vue"),
      //   props: true,
      // },

      // Un-Assigned Sourcing Request
      {
        path: '/pending-sourcing-request',
        component: () =>
          process.env?.VUE_APP_ENABLE_PROCUREMENT_MENU_PENDING_SR === 'yes'
            ? import('../views/procurement/pending-sourcing-request/List.vue')
            : import('../views/ErrorNotFound.vue'),
      },
      {
        path: '/pending-sourcing-request/view/:nonCartId',
        component: () =>
          process.env?.VUE_APP_ENABLE_PROCUREMENT_MENU_PENDING_SR === 'yes'
            ? import('../views/procurement/pending-sourcing-request/View.vue')
            : import('../views/ErrorNotFound.vue'),
        props: true,
      },
      // Work Order
      {
        path: '/work-order',
        component: () =>
          import('../views/procurement/work-order/WorkOrder.vue'),
      },
      {
        path: '/work-order/new',
        component: () => import('../views/procurement/work-order/Edit.vue'),
        props: true,
      },
      {
        path: '/work-order/edit/:workOrderId',
        component: () => import('../views/procurement/work-order/Edit.vue'),
        props: true,
      },
      {
        path: '/work-order/view/:workOrderId',
        component: () => import('../views/procurement/work-order/View.vue'),
        props: true,
      },
      {
        path: '/questionnaire',
        component: () =>
          import('../views/procurement/questionnaire/Questionnaire.vue'),
      },
      {
        path: '/questionnaire/create',
        component: () =>
          import('../views/procurement/questionnaire/Create.vue'),
      },
      {
        path: '/questionnaire/edit/:id',
        component: () => import('../views/procurement/questionnaire/Edit.vue'),
        props: true,
      },
      {
        path: '/questionnaire/view/:id',
        component: () => import('../views/procurement/questionnaire/View.vue'),
        props: true,
      },
      // e-RFQ/e-Quotation
      {
        path: '/e-rfq-quotation',
        component: () =>
          import('../views/procurement/e-rfq-quotation/EQuotation.vue'),
      },
      // e-Bidding
      {
        path: '/e-bidding',
        component: () => import('../views/procurement/e-bidding/EBidding.vue'),
      },
      // e-Auction
      {
        path: '/e-auction',
        component: () => import('../views/procurement/e-auction/EAuction.vue'),
      },
      // Convert Catalog
      {
        path: '/convert-catalog',
        component: () =>
          import('../views/procurement/convert-catalog/ConvertCatalog.vue'),
      },
      // Catalog List
      {
        path: '/catalog-list',
        component: () =>
          import('../views/procurement/catalog-list/CatalogList.vue'),
      },
      // Convert BPO
      {
        path: '/convert-bpo',
        component: () =>
          import('../views/procurement/convert-bpo/ConvertBPO.vue'),
      },
      // Purchase Order
      {
        path: '/po-submit',
        component: () =>
          import('../views/procurement/purchase-order/SubmitList.vue'),
      },
      {
        path: '/po-submit/in-process/:poId?',
        component: () =>
          import('../views/procurement/purchase-order/InProcess.vue'),
        props: true,
      },
      {
        path: '/po-submit/history/:poId?',
        component: () =>
          import('../views/procurement/purchase-order/History.vue'),
        props: true,
      },
      {
        path: '/po-submit/waiting-for-approval/:poId?',
        component: () =>
          import('../views/procurement/purchase-order/WaitingForApproval.vue'),
        props: true,
      },
      {
        path: '/po-submit/cancel/in-process/:poId',
        component: () =>
          import(
            '../views/procurement/purchase-order/CancelPOProcurementDetail.vue'
          ),
        props: (route) => ({
          poId: route.params.poId,
          mode: 'in-process',
        }),
      },
      {
        path: '/po-submit/cancel/history/:poId',
        component: () =>
          import(
            '../views/procurement/purchase-order/CancelPOProcurementDetail.vue'
          ),
        props: (route) => ({
          poId: route.params.poId,
          mode: 'history',
        }),
      },
      // Contract
      {
        path: '/contract',
        component: () => import('../views/procurement/contract/Contract.vue'),
      },
      // Blanket PO
      {
        path: '/blanket-po',
        component: () =>
          import('../views/procurement/blanket-po/BlanketPO.vue'),
      },
      // Goods Receipt
      {
        path: '/goods-receipt',
        component: () =>
          import('../views/procurement/goods-receipt/GoodsReceipt.vue'),
      },
      {
        path: '/goods-receipt/in-process/:poBillingId',
        component: () =>
          import('../views/procurement/goods-receipt/InProcess.vue'),
        props: true,
      },
      {
        path: '/goods-receipt/waiting-for-approval/:poBillingId',
        component: () =>
          import('../views/procurement/goods-receipt/WaitingForApproval.vue'),
        props: true,
      },
      {
        path: '/goods-receipt/blocked-invoice/:poBillingId',
        component: () =>
          import('../views/procurement/goods-receipt/BlockedInvoice.vue'),
        props: true,
      },
      {
        path: '/goods-receipt/history/:poBillingId',
        component: () =>
          import('../views/procurement/goods-receipt/History.vue'),
        props: true,
      },
      {
        path: '/change-delivery',
        component: () =>
          import('../views/procurement/change-delivery/ChangeDeliveryList.vue'),
      },
      {
        path: '/change-delivery/in-process/:poReceiptDateId',
        component: () =>
          import('../views/procurement/change-delivery/InProcess.vue'),
        props: true,
      },
      {
        path: '/change-delivery/history/:poReceiptDateId',
        component: () =>
          import('../views/procurement/change-delivery/History.vue'),
        props: true,
      },
      // Blacklist
      {
        path: '/blacklist',
        component: () => import('../views/procurement/blacklist/Blacklist.vue'),
      },
      {
        path: '/blacklist/create-blacklist',
        component: () =>
          import('../views/procurement/blacklist/CreateBlacklist.vue'),
      },
      {
        path: '/blacklist/edit-blacklist/:vendorBlacklistId',
        component: () =>
          import('../views/procurement/blacklist/EditBlacklist.vue'),
        props: true,
      },
      {
        path: '/blacklist/view-blacklist/:vendorBlacklistId',
        component: () =>
          import('../views/procurement/blacklist/ViewBlacklist.vue'),
        props: true,
      },

      // Non-Movement
      {
        path: '/non-movement',
        component: () =>
          import('../views/procurement/non-movement/NonMovement.vue'),
      },
      // Operation
      {
        path: '/operation-report',
        component: () => import('../views/procurement/operation/List.vue'),
      },
      {
        path: '/operation-report/1',
        component: () =>
          import('../views/procurement/operation/VendorEvaluation.vue'),
      },
      {
        path: '/operation-report/2',
        component: () =>
          import('../views/procurement/operation/GREvaluation.vue'),
      },
      {
        path: '/dashboard',
        component: () => import('../views/procurement/dashboard/Dashboard.vue'),
      },
      // Bill Placement
      {
        path: '/bill-placement',
        component: () => import('../views/procurement/bill-placement/List.vue'),
      },
      {
        path: '/bill-placement/header/create',
        component: () =>
          import('../views/procurement/bill-placement/create/Header.vue'),
      },
      {
        path: '/bill-placement/items/update/:data',
        component: () =>
          import('../views/procurement/bill-placement/update/Items.vue'),
        props: true,
      },
      {
        path: '/bill-placement/gr/:billingItemId',
        component: () =>
          import('../views/procurement/bill-placement/gr/ViewGR.vue'),
        props: true,
      },
      {
        path: '/bill-placement/view/:data',
        component: () =>
          import('../views/procurement/bill-placement/view/View.vue'),
        props: true,
      },
    ],
    meta: {
      requireAuth: true,
      requireRole: 'Procurement',
    },
  },
  {
    path: '/view-po/:poId?',
    component: () => import('../views/ViewPO.vue'),
    props: true,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/view-pr/:cartId?',
    component: () => import('../views/ViewPR.vue'),
    props: true,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/view-sr/:nonCartId?',
    component: () => import('../views/ViewSR.vue'),
    props: true,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/view-receipt/:poReceiptId?',
    component: () => import('../views/ViewReceipt.vue'),
    props: true,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/view-gr/:poBillingData?',
    component: () => import('../views/ViewGR.vue'),
    props: true,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/view-sourcing-detail/:nonCartId?',
    component: () => import('../views/ViewSourcingDetail.vue'),
    props: true,
    meta: {
      requireAuth: true,
    },
  },

  // Approver
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      // Notification
      {
        path: '/approver-notification',
        component: () =>
          import('../views/approver/notification/Notification.vue'),
      },
      // Purchase Request
      {
        path: '/pr-approval',
        component: () =>
          import('../views/approver/purchase-request/ApprovalList.vue'),
      },
      {
        path: '/pr-approval/in-process/:prApprovalItemId',
        component: () =>
          import('../views/approver/purchase-request/InProcess.vue'),
        props: true,
      },
      {
        path: '/pr-approval/history/:prApprovalItemId',
        component: () =>
          import('../views/approver/purchase-request/History.vue'),
        props: true,
      },
      // Sourcing Request
      {
        path: '/sourcing-approval',
        component: () =>
          import('../views/approver/sourcing-request/SourcingRequest.vue'),
      },
      {
        path: '/sourcing-approval/in-process/:nonCartApprovalItemId',
        component: () =>
          import('../views/approver/sourcing-request/InProcess.vue'),
        props: true,
      },
      {
        path: '/sourcing-approval/history/:nonCartApprovalItemId',
        component: () =>
          import('../views/approver/sourcing-request/History.vue'),
        props: true,
      },
      // Stock Request
      {
        path: '/approver-stock-request',
        component: () =>
          import('../views/approver/stock-request/StockRequest.vue'),
      },
      // Payment Request
      {
        path: '/payment-request-approval',
        component: () =>
          import('../views/approver/payment-request/PaymentRequest.vue'),
      },
      {
        path: '/payment-request-approval/in-process/:paymentApprovalItemId',
        component: () =>
          import('../views/approver/payment-request/InProcess.vue'),
        props: true,
      },
      {
        path: '/payment-request-approval/history/:paymentApprovalItemId',
        component: () =>
          import('../views/approver/payment-request/History.vue'),
        props: true,
      },
      // Modify Contract
      {
        path: '/approver-modify-contract',
        component: () =>
          import('../views/approver/modify-contract/ModifyContract.vue'),
      },
      // Purchase Order
      {
        path: '/po-approval',
        component: () =>
          import('../views/approver/purchase-order/ApprovalList.vue'),
      },
      {
        path: '/po-approval/in-process/:poApprovalItemId',
        component: () =>
          import('../views/approver/purchase-order/InProcess.vue'),
        props: true,
      },
      {
        path: '/po-approval/history/:poApprovalItemId',
        component: () => import('../views/approver/purchase-order/History.vue'),
        props: true,
      },
      {
        path: '/cancel-po-approval',
        component: () =>
          import('../views/approver/purchase-order/CancelPOApprovalList.vue'),
      },
      {
        path: '/cancel-po-approval/in-process/:cancelApprovalItemId',
        component: () =>
          import('../views/approver/purchase-order/CancelPOApprovalDetail.vue'),
        props: (route) => ({
          cancelApprovalItemId: route.params.cancelApprovalItemId,
          mode: 'in-process',
        }),
      },
      {
        path: '/cancel-po-approval/history/:cancelApprovalItemId',
        component: () =>
          import('../views/approver/purchase-order/CancelPOApprovalDetail.vue'),
        props: (route) => ({
          cancelApprovalItemId: route.params.cancelApprovalItemId,
          mode: 'history',
        }),
      },
      // Procurement Sourcing
      {
        path: '/procurement-sourcing-approval',
        component: () =>
          import(
            '../views/approver/procurement-sourcing/ProcurementSourcing.vue'
          ),
      },
      {
        path: '/procurement-sourcing-approval/in-process/:sourcingApprovalItemId',
        component: () =>
          import('../views/approver/procurement-sourcing/InProcess.vue'),
        props: true,
      },
      {
        path: '/procurement-sourcing-approval/history/:sourcingApprovalItemId',
        component: () =>
          import('../views/approver/procurement-sourcing/History.vue'),
        props: true,
      },
      // Blanket PO
      {
        path: '/approver-blanket-po',
        component: () => import('../views/approver/blanket-po/BlanketPO.vue'),
      },
      // Blacklist
      {
        path: 'approver-blacklist-list',
        component: () =>
          import('../views/approver/blacklist/BlApproveList.vue'),
      },
      {
        path: 'approver-blacklist-list/approver-blacklist/:blId?',
        component: () =>
          import('../views/approver/blacklist/ViewBlApprove.vue'),
        props: true,
      },
    ],
    meta: {
      requireAuth: true,
      requireRole: 'Approver',
    },
  },
  // Administrator
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      // Catalog
      {
        path: '/edit-catalog/:productDetailId?',
        name: 'edit-catalog',
        component: () => import('../views/administrator/EditCatalogPage.vue'),
        props: true,
      },
      {
        path: '/edit-catalog/product-details/:catalogItemId/:productTitle?',
        name: 'edit-catalog-product-details',
        component: () =>
          import('../views/administrator/catalog/EditProductDetails.vue'),
        props: true,
      },
      {
        path: '/edit-catalog/search-result',
        name: 'edit-search-result',
        component: () =>
          import('../views/administrator/EditSearchResultPage.vue'),
      },
      {
        path: '/edit-catalog/upload-catalog',
        name: 'upload-catalog',
        component: () => import('../views/administrator/UploadCatalogPage.vue'),
      },
      // Administrator Menu
      {
        path: '/administrator',
        redirect: '/administrator/update-delivery-date',
      },
      {
        path: '/administrator/regenerate-approval',
        component: () =>
          import(
            '../views/administrator/regenerate-approval/RegenerateApproval.vue'
          ),
      },
      {
        path: '/administrator/update-delivery-date',
        component: () =>
          import(
            '../views/administrator/update-delivery-date/UpdateDeliveryDate.vue'
          ),
      },
      {
        path: '/administrator/update-retention',
        component: () =>
          import('../views/administrator/update-retention/UpdateRetention.vue'),
      },
      {
        path: '/administrator/update-status',
        component: () =>
          import('../views/administrator/update-status/UpdateStatus.vue'),
      },
      {
        path: '/administrator/close-po',
        component: () => import('../views/administrator/close-po/ClosePO.vue'),
      },
      {
        path: '/administrator/delegate-transactions',
        component: () =>
          import(
            '../views/administrator/delegate-transactions/DelegateTransactions.vue'
          ),
      },
    ],
    meta: {
      requireAuth: true,
      requireRole: 'Administrator',
    },
  },
  // FI AP
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      {
        path: '/fi-ap/gr',
        component: () => import('../views/fi-ap/goods-receipt/GrList.vue'),
      },
      {
        path: '/fi-ap/gr/:billingItemId',
        component: () =>
          import('../views/fi-ap/goods-receipt/ViewDocument.vue'),
        props: true,
      },
    ],
    meta: {
      requireAuth: true,
      requireRole: ["FI AP", "Administrator"],
    },
  },
  // Home
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      {
        path: '/home',
        component: () => import('../views/procurement/home/HomePage.vue'),
        meta: {
          requireAuth: true,
          requireRole: 'Procurement',
        },
      },
      {
        path: '/home2',
        component: () => import('../views/approver/home/HomePage.vue'),
        meta: {
          requireAuth: true,
          requireRole: 'Approver',
        },
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  // Dev Pages
  {
    path: '/',
    component: () => import('../layouts/LoginLayout.vue'),
    children: [
      {
        path: '/print-pdf/:poId',
        component: () =>
          import('../views/procurement/purchase-order/PrintPDF.vue'),
        props: true,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: '/trigger-po-submit',
        component: () =>
          import('../views/procurement/purchase-order/TriggerPoSubmit.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/trigger-pr-approval',
        component: () =>
          import('../views/approver/purchase-request/TriggerPrApproval.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/trigger-non-cart-approval',
        component: () =>
          import(
            '../views/approver/sourcing-request/TriggerNonCartApproval.vue'
          ),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/update-po-from-excel',
        component: () => import('../views/UpdateDataFromExcel.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/trigger-convert-non-cart',
        component: () => import('../views/TriggerConvertNonCart.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/generate-pr-approval',
        component: () => import('../views/GeneratePrApproval.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/generate-payment-approval',
        component: () => import('../views/GeneratePaymentApproval.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/re-calculate-po-approval',
        component: () => import('../views/ReCalculatePOApproval.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/generate-po-approval',
        component: () => import('../views/GeneratePOApproval.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/trigger-approvers-interval',
        component: () => import('../views/Trigger1stApproversInterval.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/trigger-create-po-approvals-interval',
        component: () =>
          import('../views/TriggerCreatePOApprovalsInterval.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/cancel-po-document',
        component: () => import('../views/CancelPODocument.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/close-po-document',
        component: () => import('../views/ClosePODocument.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
      {
        path: '/change-po-delivery-date',
        component: () => import('../views/ChangePODeliveryDate.vue'),
        meta: {
          requireAuth: true,
          requireUserNameCase: true,
        },
      },
    ],
  },
  // Error Not Found
  {
    path: '/:catchAll(.*)*',
    component: () => import('../views/ErrorNotFound.vue'),
  },
  // Tess Upload File
  {
    path: '/upload-file',
    component: () => import('../views/FileUploading.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    const msInstance = getModuleSettingInstance();

    if (msInstance.isAuthenticated()) {
      const roles = sessionStorage.getItem('roles')
        ? JSON.parse(sessionStorage.getItem('roles'))
        : [];

      if (roles.length) {
        let isMatched = to.meta.requireRole ? false : true;
        let matchedRole = null;
        let isUserNameCaseCorrect = true;

        for (const role of roles) {
          const requireRole = to.meta.requireRole;
          const matched = Array.isArray(requireRole)
            ? requireRole.includes(role)
            : role === requireRole;
          if (matched) {
            isMatched = true;
            matchedRole = role;
            break;
          }
        }

        if (
          to.meta.requireUserNameCase &&
          process.env.VUE_APP_EMAIL_URL === 'https://p2p.centralpattana.co.th'
        ) {
          if (store.getters.user.userName.toLowerCase() === 'p2p.support') {
            isUserNameCaseCorrect = true;
          } else {
            isUserNameCaseCorrect = false;
          }
        } else if (
          to.meta.requireUserNameCase &&
          process.env.VUE_APP_EMAIL_URL !== 'https://p2p.centralpattana.co.th'
        ) {
          if (
            store.getters.user.userName.toUpperCase().includes('CPNPRJ') ||
            store.getters.user.userName.toLowerCase() === 'p2p.support'
          ) {
            isUserNameCaseCorrect = true;
          } else {
            isUserNameCaseCorrect = false;
          }
        }

        if (isMatched && isUserNameCaseCorrect) {
          store.dispatch(UPDATE_ROLE, matchedRole || to.meta.requireRole);
          next();
        } else {
          Dialog.create({
            message: 'คุณไม่มีสิทธิเข้าถึงหน้านี้ได้ กรุณาติดต่อผู้ดูแลระบบ..',
            type: 'negative',
            color: 'gold',
            ok: 'รับทราบ',
          }).onOk(() => {
            store.dispatch(UPDATE_ROLE, 'Requester');
            next('/catalog');
          });
        }
      } else {
        next();
      }
    } else {
      // Save the intended destination before redirecting to login
      if (to.path !== '/login') {
        sessionStorage.setItem('redirectAfterLogin', to.fullPath);
      }
      next('/login');
    }
  } else {
    next();
  }
});

export default router;
